import { render, staticRenderFns } from "./CrearContratoConvenio.vue?vue&type=template&id=20edf9f4"
import script from "./CrearContratoConvenio.vue?vue&type=script&lang=js"
export * from "./CrearContratoConvenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports